module.exports = {"120119001":"文昌街道","120119100":"渔阳镇","120119101":"洇溜镇","120119102":"官庄镇","120119103":"马伸桥镇","120119104":"下营镇","120119105":"邦均镇","120119106":"别山镇","120119108":"尤古庄镇","120119109":"上仓镇","120119111":"下仓镇","120119112":"罗庄子镇","120119113":"白涧镇","120119115":"侯家营镇","120119116":"桑梓镇","120119117":"东施古镇","120119118":"下窝头镇","120119119":"杨津庄镇","120119120":"出头岭镇","120119121":"西龙虎峪镇","120119122":"穿芳峪镇","120119123":"东二营镇","120119124":"许家台镇","120119125":"礼明庄镇","120119126":"东赵各庄镇","120119127":"州河湾镇","120119203":"孙各庄乡","120119401":"天津市蓟州区京津州河科技产业园管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/120119.json
// module id = 140
// module chunks = 0